// extracted by mini-css-extract-plugin
export default {"form__container":"NewTask_form__container__XAPlv","form__label":"NewTask_form__label__SNPVm","form__input":"NewTask_form__input__M0O+Q"};